import React, { Component } from "react";

class NoData extends Component {
  render() {
    return (
      <div className="noData">
        <div className="noDataTitle">Nothing to display yet!</div>
        {/*<div className="noDataComment">
          It looks like you don't have data created yet.
        </div>*/}
      </div>
    );
  }
}

export default NoData;



// WEBPACK FOOTER //
// ./src/components/utilities/NoData.js